import Blink from '@components/Blink'
import SvgIcon from '@components/SvgIcon'
import config from '@config'
import translate from '@i18n'
import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'

const {
  gdpr: { dataPrivacyUrl },
} = config

const StyledBlink = styled(Blink)`
  ${({
    theme: {
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    color: ${grey_100};
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`

const StyledSvgIcon = styled(SvgIcon)`
  margin-right: 8px;
`

const GDPRLink: FunctionComponent = () => {
  const theme = useTheme()
  return (
    <StyledBlink
      href={dataPrivacyUrl}
      ariaLabel={translate('config.gdprTitle')}>
      <StyledSvgIcon
        iconName="gdpr"
        size={24}
        color={theme.colors.grey.grey_80}
      />
      {translate('config.gdprTitle')}
    </StyledBlink>
  )
}

export default GDPRLink
